export let calendarMonth_January = "pDnC2";
export default {calendarMonth_January};